const getTimeoutSignal = (timeout: number): AbortSignal | undefined => {
  if (typeof timeout !== 'number' || timeout <= 0) {
    return undefined;
  }
  if (typeof window.AbortSignal?.timeout === 'function') {
    return AbortSignal.timeout(timeout);
  } else {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), timeout);
    return controller.signal;
  }
};
export default getTimeoutSignal;
